import { Text } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const RiderNotesContainer = styled(Text)`
  display: block;
  display: -webkit-box;
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 !important;

  max-height: calc(1em * 1.2 * 3); /* for non-Webkit browsers support */
  -webkit-line-clamp: 3;
`;

export const LightText = styled.span`
  font-weight: 300;
`;
